import { Input } from "@/components/ui/input";
import { Building } from "lucide-react";

interface BankAccountFormProps {
  bankNumber: string;
  onBankNumberChange: (value: string) => void;
}

export const BankAccountForm = ({ bankNumber, onBankNumberChange }: BankAccountFormProps) => {
  return (
    <div className="space-y-4">
      <Input
        type="text"
        placeholder="Routing Number"
        className="w-full"
        maxLength={9}
      />
      <Input
        type="text"
        placeholder="Account Number"
        value={bankNumber}
        onChange={(e) => onBankNumberChange(e.target.value)}
        className="w-full"
        maxLength={12}
      />
    </div>
  );
};